import 'jquery';
import 'jquery-ui/dist/jquery-ui.min.js'
import 'slick-carousel';
import '@fancyapps/fancybox';
import Headroom from 'headroom.js';
import '/src/js/app.yearofentrycalculator.js';

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    var items = document.querySelectorAll(".fade-in");
    items.forEach(function (item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Home page animation
   ========================================================================== */

//Feature slider line animation
if (document.querySelector(".feature-slider")) {
    if ('IntersectionObserver' in window) {
        var featureSliderTrigger = document.querySelector(".feature-slider");
        var handler = function handler(entries) {
            if (entries[0].isIntersecting) {
                setTimeout(() => {
                    $(".feature-slider__line").addClass("animate-line-in");
                }, 500);
                setTimeout(() => {
                    $(".feature-slider__line").addClass("animate-line-out");
                }, 2000);
            }
        };
        var observer = new window.IntersectionObserver(handler);
        observer.observe(featureSliderTrigger);
    }
}
// Fade in Hero header, slideshow buttons after delay (desktop only)
if (document.querySelector(".banner-hero")) {
    if (window.matchMedia("(min-width: 1024px)").matches) {
        setTimeout(() => {
            $(".header").fadeIn(800);
            $(".banner-hero__slider-buttons").fadeIn(800);
        }, 4500);
    }
}

// Fade in Hero header, slideshow buttons after delay (desktop only)
if (document.querySelector(".banner-hero")) {
    if (window.matchMedia("(min-width: 1024px)").matches) {
        setTimeout(() => {
            $(".header").fadeIn(800);
            $(".banner-hero__slider-buttons").fadeIn(800);
        }, 4500);
    }
}

// Animate slideshow text
if (document.querySelector(".banner-hero")) {
    if (window.matchMedia("(min-width: 1024px)").matches) {
        $('.js-hero-slider').on('init', function(event, slick, currentSlide){
            setTimeout(() => {
                $(".slick-current .banner-hero__slider-slide").addClass("animate-line-in");
            }, 500);
            setTimeout(function(){
                $(".slick-current .banner-hero__slider-slide").addClass("animate-line-out");
                $('.slick-current .banner-hero__slider-slide').addClass('animate-text');
            },2000);
        });
    } else {
        $('.js-hero-slider').on('init', function(event, slick, currentSlide){
            setTimeout(function(){
                $('.slick-current .banner-hero__slider-slide').addClass('animate-text');
            },25);
        });
    }

    $('.js-hero-slider').on('afterChange', function(event, slick, currentSlide){
        $('.banner-hero__slider-slide').removeClass('animate-text').removeClass('animate-line-in').removeClass('animate-line-out');
        setTimeout(function(){
            $('.slick-current .banner-hero__slider-slide').addClass('animate-text');
        },25);
        setTimeout(() => {
            $(".slick-current .banner-hero__slider-slide").addClass("animate-line-in");
        }, 100);
        setTimeout(() => {
            $(".slick-current .banner-hero__slider-slide").addClass("animate-line-out");
        }, 1600);
    });
}

// Force finish animation on scroll
if (document.querySelector(".banner-hero")) {
    if ("IntersectionObserver" in window) {
        var sentinalEl = document.querySelector(".banner-hero__logo");
        var heroBannerHandler = function handler(entries) {
            if (!entries[0].isIntersecting && window.scrollY > 0) {

                // Animate banner text
                $('.slick-active .banner-hero__slider-slide').addClass('animate-text');

                // Animate line in/out
                $(".slick-active .banner-hero__slider-slide").addClass("animate-line-in");
                setTimeout(() => {
                    $(".slick-active .banner-hero__slider-slide").addClass("animate-line-out");
                }, 2000);

                // Show header
                $(".header").fadeIn(800);

                // Show slider buttons
                $(".banner-hero__slider-buttons").fadeIn(800);
            }
        };
        var heroBannerObserver = new window.IntersectionObserver(heroBannerHandler);
        heroBannerObserver.observe(sentinalEl);
    }
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

$(".js-trigger-mobile-nav").click(function () {
    $(".main-nav").fadeToggle(250);
    $(this).toggleClass("is-active");
    $("body").toggleClass("lock-scroll");

    // Close the sub nav
    $(".sub-nav").fadeOut(250);
    $(".main-nav__link").removeClass("is-active");

    // Close the quicklinks nav
    $(".quick-links__dropdown").fadeOut(250);
    $(".quick-links__button").removeClass("is-active");
});

/* ==========================================================================
   Sub Nav
   ========================================================================== */

$(".js-toggle-subnav").click(function (e) {
    e.preventDefault();
    // Open the sub nav
    var thisNav = $(this).parent().find(".sub-nav");
    $(".main-nav__link").not(this).removeClass("is-active");
    $(".sub-nav").not(thisNav).fadeOut(250);
    $(this).toggleClass("is-active");
    $(this).parent().find(".sub-nav").fadeToggle(250);

    // Close the quicklinks nav
    $(".quick-links__dropdown").fadeOut(250);
    $(".quick-links__button").removeClass("is-active");
});

$(".js-close-subnav").click(function (e) {
    e.preventDefault();
    // Close the sub nav
    $(".sub-nav").fadeOut(250);
    $(".main-nav__link").removeClass("is-active");
});

/* ==========================================================================
   Quick Links Nav
   ========================================================================== */

$(".js-toggle-quicklinks").click(function (e) {
    e.preventDefault();
    // Open the quicklinks nav
    $(".quick-links__button").toggleClass("is-active");
    $(".quick-links__dropdown").fadeToggle(250);

    // Close the sub nav
    $(".sub-nav").fadeOut(250);
    $(".main-nav__link").removeClass("is-active");

    // Close the mobile nav
    $(".main-nav").fadeOut(250);
    $(".js-trigger-mobile-nav").removeClass("is-active");
    $("body").removeClass("lock-scroll");

    $(".quick-links-search .quick-links-search__input input").focus();
});

$(".js-close-quicklinks").click(function (e) {
    e.preventDefault();
    // Close the quicklinks nav
    $(".quick-links__dropdown").fadeOut(250);
    $(".quick-links__button").removeClass("is-active");
});
/* ==========================================================================
   Page Links mobile nav
   ========================================================================== */

$(".page-nav__button").click(function (e) {
    e.preventDefault();
    // Open the page mobile nav
    $(this).toggleClass("is-active");
    $(".page-nav__inner").fadeToggle(250);
});

/* ==========================================================================
   Side nav mobile
   ========================================================================== */

$(".side-nav__button").click(function (e) {
    e.preventDefault();
    // Open the page mobile nav
    $(this).toggleClass("is-active");
    $(".side-nav__inner").fadeToggle(250);
});

/* ==========================================================================
   Copy header buttons into main nav for mobile
   ========================================================================== */

$('.header-buttons-list').clone().prependTo('.main-nav');

/* ==========================================================================
   Change header on scroll
   ========================================================================== */

if (document.querySelector(".header")) {
    var headroomOptions = {
        offset: {
            up: 0,
            down: 20
        },
        onUnpin: function () {
            $(".sub-nav").hide();
            $(".main-nav__link").removeClass("is-active");
        }
    }
    const headroomHeader = document.querySelector(".header");
    const headroom = new Headroom(headroomHeader, headroomOptions);
    headroom.init();
}

/* ==========================================================================
   Slick Sliders
   ========================================================================== */
var heroSlider = $('.js-hero-slider');

heroSlider.slick({
    fade: false,
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>',
    appendArrows: $(".banner-hero__slider-buttons-inner"),
    responsive: [
        {
            breakpoint: 768,
            settings: {
                fade: true
            }
        }
    ]
}).slick("slickPause");

setTimeout(function() {
    heroSlider.slick("slickPlay");
},3000);


$('.js-feature-slider').slick({
    fade: true,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>',
    appendArrows: $(".feature-slider__slider-buttons")
});

$('.mobile-slider-two-column').slick({
    fade: false,
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 768,
            settings: "unslick"
        }
    ]
});

$('.mobile-slider-one-column').slick({
    fade: false,
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 768,
            settings: "unslick"
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
            }
        }
    ]
});


$('.page-nav__list').slick({
    fade: false,
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    variableWidth: true,
    swipeToSlide: true,
    responsive: [
        {
            breakpoint: 1025,
            settings: "unslick"
        }
    ]
});

/* ==========================================================================
  jQuery UI - Accordion
   ========================================================================== */

if (document.querySelector(".accordion")) {
    $(".accordion").accordion({
        collapsible: true,
        heightStyle: "content",
        active: false
    });
}

/* ==========================================================================
  Responsive tables
   ========================================================================== */

$("main table").each(function() {
    $(this).wrap("<div class='responsive-table'></div>");
});

